const func = $target => {
    $(document).ready(function(){
        $(".product-item").hide();
        
        $(".product-item-odd").slice(0,2).show();
        $(".product-item-even").slice(0,2).show();
        
        $("#read-more-btn").click(function(e){
            e.preventDefault();
            $(".product-item-odd:hidden").slice(0,2).fadeIn("slow");
            $(".product-item-even:hidden").slice(0,2).fadeIn("slow");

            if($(".product-item:hidden").length == 0){
                $("#read-more-wrapper").removeClass('d-block');
                $("#read-more-wrapper").hide();
                $(".bg-white-fade").hide()
            }
        });
    })
};


export default func;